import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import { gFormatNumber } from "../../util";
import theme from "../Theme";
import { translate } from "../../i18n/customI18nProvider";
import { cyan } from '@mui/material/colors';

const graph_colors_history = [
    theme.palette.primary.main,
    cyan[400]
];

const titleTextStyle = {
    color: theme.palette.primary.main,
    fontSize: 24,
    bold: true,
};

class PeopleInEventLineChart extends Component {
    render() {
        const { historyPeople } = this.props;
        const people = [[
            translate('custom.date'),
            translate('custom.people_in_event'),
        ]];
        let found = false;

        for (let i = 0; i < historyPeople.length; i++) {
            people.push([
                new Date(historyPeople[i]["date"]),
                gFormatNumber(historyPeople[i]["people"]),
            ]);
            if (historyPeople[i]["people"] !== 0) {
                found = true;
            }
        }

        if (found) {
            let view = (
                <Chart
                    chartType="LineChart"
                    width="100%"
                    height="500px"
                    data={people ?? []}
                    options={{
                        title: translate('custom.people_in_event'),
                        titleTextStyle,
                        vAxis: {
                            title: translate('custom.number'),
                            format: 'short'
                        },
                        hAxis: {
                            format: translate('custom.OPTIONS.chart_date_time_format')
                        },
                        colors: graph_colors_history,
                        backgroundColor: { fill: 'transparent' },
                        legend: { position: 'bottom' }
                    }}
                    graph_id="PeopleInEventChart"
                />
            );

            return (
                <div>
                    {view}
                </div>
            )
        }
        return null;
    }
}

export default PeopleInEventLineChart;